import { useCallback } from 'react';
import { useErrorToast } from '../../components/common';

/** Map SDA ErrorToast API to survey-runtime toast naming */
export function useSurveyUiToast() {
  const { showErrorToast, showSuccessToast } = useErrorToast();
  const showError = useCallback((message) => showErrorToast(message), [showErrorToast]);
  const showSuccess = useCallback((message) => showSuccessToast(message), [showSuccessToast]);
  return {
    showError,
    showSuccess,
  };
}
